import PropTypes from 'prop-types';
import './select.scss';
import Swal from "sweetalert2";

export const Select = (props) => {
    const { error, children, label, required, input, onChange, disabled, help, autocomplete, ariaLabelledby } = props;
    const selectId = input?.name ? `select-${input.name}` : undefined;
    const errorId = input?.name ? `error-${input.name}` : undefined;

    const showPopup = () => {
        Swal.fire({
            icon: 'info',
            text: help,
            showCloseButton: true,
            closeButtonAriaLabel: 'Fermer cette boîte de dialogue',
        });
    }

    return (
        <div className={'select-content'}>
            {label && (
                <label htmlFor={selectId} className={'label-text mb-1'}>
                    {label}
                    {required ? <><sup className={'text-danger'} aria-hidden="true">*</sup><span className="visually-hidden"> (obligatoire)</span></> : ''}
                    {help && <button type="button" className="float-end d-inline-block btn-help" style={{marginTop: '-5px'}} onClick={() => showPopup()} aria-label="Aide">?</button>}
                </label>
            )}
            <select
                id={selectId}
                onChange={onChange || null}
                {...input}
                disabled={disabled}
                className={`form-select mb-3 rounded border cursor-pointer`}
                required={required}
                aria-required={required ? 'true' : undefined}
                aria-invalid={error ? 'true' : undefined}
                aria-describedby={error ? errorId : undefined}
                aria-labelledby={ariaLabelledby || undefined}
                aria-label={!label && !ariaLabelledby ? (input?.name || 'Sélection') : undefined}
            >
                {children}
            </select>
            {error && <small id={errorId} className={'alert alert-danger invalid-feedback d-block'} role="alert">{error}</small>}
        </div>
    );
};

Select.propTypes = {
    error: PropTypes.string,
    children: PropTypes.node.isRequired,
    label: PropTypes.string,
    required: PropTypes.bool,
    input: PropTypes.object,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
};

Select.defaultProps = {
    required: false,
    disabled: false,
};
